import { apiRoutes } from './apiRoutes'
import {
  commonResponse,
  LoginResponse,
  SignupResponse,
  verifyOtpResponse,
} from '../types/APIResponseType'
import {
  LoginRequestPayload,
  ResetPasswordPayload,
  SignUpAdminPayload,
  UserEmailAndRolePayload,
} from '../types/APIRequestType'
import anklePatrolAxios from '../../../services/config/axiosClient'

export const signUpUser = (
  payload: SignUpAdminPayload,
): Promise<commonResponse<SignupResponse>> =>
  anklePatrolAxios.post(apiRoutes.signUp, payload)

export const loginUser = (
  payload: LoginRequestPayload,
): Promise<commonResponse<LoginResponse>> =>
  anklePatrolAxios.post(apiRoutes.loginAdmin, payload)

export const resetPassword = (
  payload: ResetPasswordPayload,
): Promise<commonResponse<null>> =>
  anklePatrolAxios.post(apiRoutes.resetPassword, payload)

export const forgotPassword = (
  payload: UserEmailAndRolePayload,
): Promise<commonResponse<null>> =>
  anklePatrolAxios.post(apiRoutes.forgotPassword, payload)

export const verifyOtp = (payload: {
  email: string | null
  otp: string
}): Promise<commonResponse<verifyOtpResponse>> =>
  anklePatrolAxios.post(apiRoutes.verifyOtp, payload)
